import { render, staticRenderFns } from "./Position-Dot.vue?vue&type=template&id=6b9e9d3a&lang=pug"
import script from "./Position-Dot.vue?vue&type=script&lang=ts"
export * from "./Position-Dot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports